import { AssignedProperty } from 'api/clients/PropertyClient'
import { AlmanacFile } from 'types'

export type UploadCompleteDetails = {
  file: AlmanacFile
  assignedProperty: AssignedProperty
}
export type UploadCompleteEvent = CustomEvent<UploadCompleteDetails>
export const uploadCompleteEventName = 'uploadComplete'
